import React, { useCallback, useEffect, useState} from "react";
import { useUser } from "../UserContext";
import { useNavigate } from "react-router-dom";
import { Dropdown, Button } from "react-bootstrap";
import 'bootstrap-icons/font/bootstrap-icons.css';
import {
    fetchPendingTransferRequestCount,
    fetchUnreadChatCount
} from "../api/api";

const UserMenu = ({ handleLogout }) => {
    const { user } = useUser();
    const [unreadCount, setUnreadCount] = useState(0);
    const [pendingTransferCount, setPendingTransferCount] = useState(0);
    const [isWarehouse, setIsWarehouse] = useState(false);
    // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const navigate = useNavigate();

    const refreshUnreadCount = useCallback(async () => {
        if (!user) return;
        try {
            const count = await fetchUnreadChatCount();
            setUnreadCount(count);
        } catch (error) {
            console.error('Error fetching unread chat count:', error);
        }
    }, [user]);

    const refreshPendingTransferCount = useCallback(async () => {
        if (!user) return;
        try {
            const data = await fetchPendingTransferRequestCount();
            setPendingTransferCount(Number(data?.count || 0));
            setIsWarehouse(Boolean(data?.is_warehouse));
        } catch (error) {
            console.error('Error fetching pending transfer requests:', error);
        }
    }, [user]);

    useEffect(() => {
        refreshUnreadCount();
        refreshPendingTransferCount();
        const interval = setInterval(() => {
            refreshUnreadCount();
            refreshPendingTransferCount();
        }, 30000);
        return () => clearInterval(interval);
    }, [refreshPendingTransferCount, refreshUnreadCount]);

    const handleProfileClick = () => {
        navigate('/profile');
    };

    const handleChatClick = () => {
        navigate('/chat');
    };

    if (!user) {
        return (
            <div className="user-menu">
                <Button variant="primary" onClick={() => navigate('/login')}>Login</Button>
            </div>
        );
    }

    return (
        <div className="user-menu">
            {isWarehouse && (
                <Button
                    variant="link"
                    className="chat-unread-button"
                    onClick={() => navigate('/inventory/stock-transfer')}
                    title={pendingTransferCount
                        ? `${pendingTransferCount} pending branch transfer request${pendingTransferCount === 1 ? '' : 's'}`
                        : 'Branch transfer requests'}
                    aria-label="Branch transfer requests"
                >
                    <i className="bi bi-box-arrow-in-down" style={{ fontSize: '1.35rem' }}></i>
                    {pendingTransferCount > 0 && (
                        <span className="chat-unread-badge">{pendingTransferCount}</span>
                    )}
                </Button>
            )}
            <Button
                variant="link"
                className="chat-unread-button"
                onClick={handleChatClick}
                title="Chat"
            >
                <i className="bi bi-chat-dots" style={{ fontSize: '1.35rem' }}></i>
                {unreadCount > 0 && (
                    <span className="chat-unread-badge">{unreadCount}</span>
                )}
            </Button>
            <Dropdown align="end">
                <Dropdown.Toggle variant="link" id="dropdown-user-menu" className="d-flex align-items-center">
                    <i className="bi bi-person-circle me-2" style={{ fontSize: '1.5rem' }}></i>
                    {/*<Image src="https://via.placeholder.com/30" roundedCircle alt="User Icon" className="me-2" />*/}
                    <span>{user.username}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown-menu" variant="light">
                    <Dropdown.Item onClick={handleProfileClick}>Profile</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default UserMenu;
